import api from "@/lib/api";

export interface PostPurchaseSettlementGoldRequest {
  session: string;
}

export interface PostPurchaseSettlementGoldResponse {
  status: string;
  returnUrl: string;
}

export default {
  postPurchaseSettlementGold(data: PostPurchaseSettlementGoldRequest) {
    return api<
      PostPurchaseSettlementGoldRequest,
      PostPurchaseSettlementGoldResponse
    >({
      endpoint: "purchase/settlement/web-api/gold",
      method: "POST",
      body: data
    });
  }
};
